// Analytics tracking hook for Google Analytics conversion events
export const useAnalytics = () => {
  const trackEvent = (
    eventName: string,
    eventParams?: Record<string, string | number | boolean>
  ) => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  };

  return { trackEvent };
};

// Phone call conversion — GA4 recommended event: generate_lead
export const trackPhoneClick = (phoneNumber: string, location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Standard engagement event
    window.gtag('event', 'phone_click', {
      event_category: 'engagement',
      event_label: phoneNumber,
      location,
      value: 1,
    });
    // GA4 conversion event
    window.gtag('event', 'generate_lead', {
      currency: 'TRY',
      value: 50,
      lead_source: 'phone_call',
      phone_number: phoneNumber,
      page_location: location,
    });
  }
};

// WhatsApp conversion
export const trackWhatsAppClick = (phoneNumber: string, location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'whatsapp_click', {
      event_category: 'engagement',
      event_label: phoneNumber,
      location,
      value: 1,
    });
    window.gtag('event', 'generate_lead', {
      currency: 'TRY',
      value: 40,
      lead_source: 'whatsapp',
      phone_number: phoneNumber,
      page_location: location,
    });
  }
};

// Email click conversion
export const trackEmailClick = (email: string, location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'email_click', {
      event_category: 'engagement',
      event_label: email,
      location,
      value: 1,
    });
    window.gtag('event', 'generate_lead', {
      currency: 'TRY',
      value: 30,
      lead_source: 'email',
      email_address: email,
      page_location: location,
    });
  }
};

// Social media click
export const trackSocialClick = (platform: string, location: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'social_click', {
      event_category: 'engagement',
      event_label: platform,
      location,
      value: 1,
    });
  }
};

// Form submission conversion — GA4 recommended event: generate_lead
export const trackFormSubmit = (formName: string, formLocation: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    // Standard form_submit event
    window.gtag('event', 'form_submit', {
      event_category: 'conversion',
      event_label: formName,
      location: formLocation,
      value: 5,
    });
    // GA4 conversion event (highest value lead)
    window.gtag('event', 'generate_lead', {
      currency: 'TRY',
      value: 100,
      lead_source: 'contact_form',
      form_name: formName,
      page_location: formLocation,
    });
  }
};

// CTA button click
export const trackCTAClick = (ctaText: string, ctaLocation: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'cta_click', {
      event_category: 'engagement',
      event_label: ctaText,
      location: ctaLocation,
      value: 2,
    });
  }
};
